import type { U3141Cadastre, U3141ChildLotChain } from '../U3141Service';
import type { U3141ResolveLotDetailForGraphAddResult } from '../U3141Service';
import { u3141CloneChildLotChainSnapshot } from './u3141GraphAddFormDirty';

type ResolveDistrictFn = (
  codeDistrict?: string | null,
  propertyDistrict?: string | null,
) => Promise<{ id: string; propertyDistrict?: string; codeDistrict?: string | null } | null>;

type ResolveCadastreFn = (
  districtId: string,
  cadastreCode?: string | null,
  cadastreLabel?: string | null,
  rankCode?: string | null,
  rankLabel?: string | null,
) => Promise<U3141Cadastre | null>;

/**
 * Complète district/cadastre avec id pour les autocompletes U2000 (resolve BL-0661 ne renvoie que des libellés).
 */
export async function u3141HydrateGraphAddLotDetailDistrictCadastre(
  child: U3141ChildLotChain,
  preview: NonNullable<U3141ResolveLotDetailForGraphAddResult['lotDetail']>,
  deps: { resolveDistrict: ResolveDistrictFn; resolveCadastre: ResolveCadastreFn },
): Promise<U3141ChildLotChain> {
  const next = u3141CloneChildLotChainSnapshot(child);
  if (!next.lotDetail) return next;

  const district = await deps.resolveDistrict(null, preview.propertyDistrict);
  if (district?.id) {
    next.lotDetail.district = {
      ...next.lotDetail.district,
      id: district.id,
      propertyDistrict: district.propertyDistrict ?? next.lotDetail.district.propertyDistrict,
      codeDistrict: district.codeDistrict ?? next.lotDetail.district.codeDistrict,
    };
  }

  const districtId = next.lotDetail.district?.id;
  if (districtId) {
    const rankLabel = preview.rank?.trim() || null;
    const cadastre = await deps.resolveCadastre(districtId, null, preview.cadastre, null, rankLabel);
    if (cadastre?.id) {
      next.lotDetail.cadastre = {
        ...next.lotDetail.cadastre,
        id: cadastre.id,
        cadastre: cadastre.cadastre ?? next.lotDetail.cadastre.cadastre,
        cadastreCode: cadastre.cadastreCode ?? next.lotDetail.cadastre.cadastreCode,
        rankCode: cadastre.rankCode ?? next.lotDetail.cadastre.rankCode,
        rankLabel: cadastre.rankLabel ?? next.lotDetail.cadastre.rankLabel,
        rank: cadastre.rank ?? next.lotDetail.cadastre.rank,
      };
    }
  }

  return next;
}
